module.exports = __webpack_public_path__ + "static/img/46-6.3585005.png";